var _g, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoHouseholdEffects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 50,
    viewBox: "0 0 50 50",
    width: 50,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#2d9cdb",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.58261
  }, /*#__PURE__*/React.createElement("path", {
    d: "m5 25.4322h41v14.2137h-41z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.2608 25.4322v14.2137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m31.7391 25.4322v14.2137"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5 32.539h14.2609"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m8.5652 44.9759 5.3478-5.3301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m42.4348 44.9759-5.3479-5.3301"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.3479 43.1992h30.3043"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.1305 16.5486h1.7826c.4728 0 .9262.1872 1.2605.5204s.5221.7851.5221 1.2564v7.1068h-5.3478v-7.1068c0-.4713.1878-.9232.5221-1.2564s.7877-.5204 1.2605-.5204z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.0217 16.5487c-.2511-2.677-1.4821-5.1683-3.45825-6.9985"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m45.4456 14.3401c.0658.262.0709.5355.0148.7997s-.1719.5122-.3386.7251-.3799.3852-.6235.5036c-.2435.1185-.5109.1801-.7818.1801h-13.2591c-.2709 0-.5383-.0616-.7818-.1801-.2436-.1184-.4568-.2907-.6235-.5036s-.2825-.4609-.3386-.7251-.051-.5377.0148-.7997l1.7826-7.10682c.0966-.38421.3192-.72524.6325-.96892.3132-.24369.6992-.37604 1.0966-.37605h9.6939c.3974.00001.7834.13236 1.0966.37605.3133.24368.5359.58471.6325.96892z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.0461 25.4321c.696-.7643 1.1544-1.7137 1.3195-2.7327.165-1.0191.0296-2.0639-.3898-3.0078-.4194-.9438-1.1047-1.7459-1.9727-2.309-.868-.563-1.8814-.8627-2.917-.8627-1.0357 0-2.0491.2997-2.9171.8627-.868.5631-1.5533 1.3652-1.9727 2.309-.4194.9439-.5548 1.9887-.3897 3.0078.165 1.019.6234 1.9684 1.3194 2.7327z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m23.2717 32.0949c.0882 0 .1743.026.2476.0748s.1304.1182.1642.1994c.0337.0811.0425.1705.0253.2566-.0172.0862-.0596.1653-.1219.2274-.0624.0622-.1418.1045-.2282.1216-.0865.0171-.1761.0083-.2575-.0253s-.151-.0905-.2-.1636c-.049-.073-.0751-.1589-.0751-.2467 0-.1178.0469-.2308.1305-.3141s.1969-.1301.3151-.1301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m41.9892 32.0949c.0881 0 .1743.026.2475.0748.0733.0488.1305.1182.1642.1994.0337.0811.0425.1705.0253.2566-.0172.0862-.0596.1653-.1219.2274-.0623.0622-.1418.1045-.2282.1216-.0865.0171-.1761.0083-.2575-.0253s-.151-.0905-.2-.1636c-.049-.073-.0751-.1589-.0751-.2467 0-.1178.047-.2308.1305-.3141.0836-.0833.197-.1301.3152-.1301z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.3478 7.66507c0 .70682-.2817 1.38469-.78315 1.88448-.50145.49975-1.18157.78055-1.89074.78055-1.476 0-2.67391-2.66503-2.67391-2.66503l2.67391-2.66507s2.67389 1.19395 2.67389 2.66507z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m22.7329 31.9581h1.02502v1.02502h-1.02502z",
    fill: "#2d9cdb"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m22.7329 31.9581h1.02502v1.02502h-1.02502z",
    fill: "#2d9cdb"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5934 31.9581h1.02503v1.02502h-1.02503z",
    fill: "#2d9cdb"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m41.5934 31.9581h1.02503v1.02502h-1.02503z",
    fill: "#2d9cdb"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHouseholdEffects);
export default __webpack_public_path__ + "static/media/ico_household_effects.ef36466c12cc76c46b6843ce99e279c5.svg";
export { ForwardRef as ReactComponent };